import React from "react";

import Link from "core/Link";

import { FORGOT_PASSWORD } from "js/data/links";

import { useLoginFlow } from "../Context";

const ResetPasswordViewLink = ({ children }) => {
    const { goToPasswordReset, resetPasswordIsExternal } = useLoginFlow();

    const onClick = e => {
        e.preventDefault();
        goToPasswordReset();
    };

    const href = FORGOT_PASSWORD;

    return (
        <Link
            data-testid="reset-password-view-link"
            {...(resetPasswordIsExternal
                ? { href, target: "_blank" }
                : { onClick, isButton: true })}
        >
            {children}
        </Link>
    );
};

export default ResetPasswordViewLink;
